import React from 'react'
import { IoOpenOutline } from "react-icons/io5";
import styled from 'styled-components';
const ProjectCards = ({ title, description, imgUrl, url,tools }) => {
  return (
    
      <div className='proj-imgbx'>
        <img src={imgUrl} alt={title} />
        <div className='proj-shadow'/>
        <div className='proj-txtx'>
          <h4>{title}</h4>
          <span>{description}</span>
          <div className='proj-tools'>
          {
            tools.map((tool,index)=>{
                return <Tool key={index}>{tool}</Tool>
            })
          }</div>
          <span>
            <a href={url} target='blank' className='proj-url'>
              <IoOpenOutline />
            </a>
          </span>

        </div>
      </div>
    
  );
}
const Tool = styled.span`
    font-family:"Righteous";
    padding:0.5rem;
    background: #282828;
    font-style:none;
    font-size:10px;
    font-weight:light;
    color:#fff;
    border-radius: 10px;
    border: 1px solid #eee;
    
`

export default ProjectCards
